import {
    all,
    fork
} from 'redux-saga/effects';
import {
    watchAddUserAccount,
    watchGetAccountData, watchGetAccountUsers,
    watchGetDashboard, watchGetMerchantDetails, watchGetMerchantLocations, watchGetMerchantReport, watchGetTotalLocationsCount, watchGetUserAccount, watchUpdateAccountData, watchUpdateUserAccount
} from './app';

export default function* rootSaga() {
    yield all([
        fork(watchGetDashboard),
        fork(watchGetMerchantDetails),
        fork(watchGetMerchantLocations),
        fork(watchGetMerchantReport),
        fork(watchGetAccountData),
        fork(watchGetAccountUsers),
        fork(watchGetUserAccount),
        fork(watchUpdateUserAccount),
        fork(watchUpdateAccountData),
        fork(watchAddUserAccount),
        fork(watchGetTotalLocationsCount)
    ]);
}